import { useCustom, useApiUrl } from "@refinedev/core";

interface ForbiddenZonePathEntry {
  id: number;
  placeId: number;
  userId: number;
  latitude: number;
  longitude: number;
  enteredAt: string;
  exitedAt: string | null;
  notifiedUserIds: number[];
}

interface ForbiddenZonePathPlace {
  id: number;
  name: string;
  emoji: string | null;
  address: string | null;
  latitude: number;
  longitude: number;
  radius: number;
  shapeType: "CIRCLE" | "POLYGON";
  polygon: unknown | null;
}

interface ForbiddenZonePathUser {
  id: number;
  fullname: string;
  email: string;
  profilePicture: string | null;
}

interface ForbiddenZonePathLocation {
  id: number;
  latitude: number;
  longitude: number;
  timestamp: string;
  accuracy: number | null;
}

interface ForbiddenZonePathResponse {
  entry: ForbiddenZonePathEntry;
  place: ForbiddenZonePathPlace;
  user: ForbiddenZonePathUser;
  locations: ForbiddenZonePathLocation[];
}

export function useForbiddenZonePath(entryId: number | undefined) {
  const apiUrl = useApiUrl();

  const result = useCustom<ForbiddenZonePathResponse>({
    url: `${apiUrl}/places/forbidden-zones/history/${entryId}/path`,
    method: "get",
    queryOptions: {
      queryKey: ["forbidden-zone-path", entryId],
      enabled: !!entryId,
    },
  });

  const responseData = result.data?.data;

  return {
    entry: responseData?.entry,
    place: responseData?.place,
    user: responseData?.user,
    locations: responseData?.locations ?? [],
    isLoading: result.isLoading,
  };
}

export type {
  ForbiddenZonePathEntry,
  ForbiddenZonePathPlace,
  ForbiddenZonePathUser,
  ForbiddenZonePathLocation,
  ForbiddenZonePathResponse,
};
